import { useEffect, useRef, useState } from "react"

// ATALLA-322: legenda status order/PO yang dapat dipakai ulang di berbagai list.
// Deskripsi Indonesia = perkiraan terbaik, mohon direview tim ops bila ada koreksi.
export const STATUS_DESCRIPTIONS = {
  PENDING: "Order dibuat, menunggu pembayaran dari customer.",
  PENDING_CONFIRMATION: "Pembayaran/checkout menunggu konfirmasi admin toko.",
  PENDING_APPROVAL: "Menunggu persetujuan (approval) sebelum diproses lebih lanjut.",
  PENDING_PAYMENT: "Menunggu pembayaran dari customer.",
  CONFIRMED: "Order sudah dikonfirmasi dan siap diproses.",
  PAID: "Pembayaran sudah diterima/lunas.",
  PROCEED: "Order sedang diproses (disiapkan) oleh toko/gudang.",
  PROCESSING: "Order sedang diproses (disiapkan) oleh toko/gudang.",
  SHIPPING: "Barang dalam pengiriman ke customer.",
  READY_TO_PICKUP: "Barang siap diambil customer di outlet.",
  RECEIVED: "Barang sudah diterima customer.",
  DONE: "Order selesai sepenuhnya.",
  COMPLETED: "Order selesai sepenuhnya.",
  APPROVED: "Permintaan disetujui.",
  REJECTED: "Permintaan ditolak.",
  CANCELED: "Order dibatalkan.",
  CANCELLED: "Order dibatalkan.",
  VOID: "Order dibatalkan/dianulir (void) setelah sempat tercatat.",
  SUBMITTED: "Permintaan sudah diajukan, menunggu ditindaklanjuti.",
}

const humanize = (code) =>
  String(code || "")
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase())

/**
 * Tombol info kecil + popover yang menjelaskan arti tiap status (Bahasa Indonesia).
 * @param {(string|{value: string, label?: string, description?: string})[]} [statuses]
 *   daftar status yang ingin ditampilkan; kosong = semua.
 *   150726 (ATALLA-322): selain kode string (pakai STATUS_DESCRIPTIONS), sekarang juga
 *   menerima objek {value, label, description} utk deskripsi khusus per halaman
 *   (dipakai list PO / penerimaan barang / retur).
 */
export default function StatusInfo({ statuses, className = "" }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    if (!open) return
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener("mousedown", onClick)
    return () => document.removeEventListener("mousedown", onClick)
  }, [open])

  // 150726 (ATALLA-322): normalisasi item string maupun objek {value, label, description}.
  const entries = (Array.isArray(statuses) && statuses.length ? statuses : Object.keys(STATUS_DESCRIPTIONS))
    .map((item) =>
      item && typeof item === "object"
        ? {
            value: item.value,
            label: item.label || humanize(item.value),
            description: item.description || STATUS_DESCRIPTIONS[String(item.value).toUpperCase()] || "Status.",
          }
        : {
            value: item,
            label: humanize(item),
            description: STATUS_DESCRIPTIONS[String(item).toUpperCase()] || "Status.",
          }
    )
    .filter((entry) => entry.value && entry.value !== "ALL" && entry.value !== "default")

  return (
    <span ref={ref} className={`relative inline-flex ${className}`}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        title="Keterangan status"
        aria-label="Keterangan status"
        className="inline-flex items-center justify-center w-5 h-5 text-[11px] font-bold text-neutral-500 border border-neutral-300 rounded-full hover:bg-neutral-100"
      >
        i
      </button>
      {open && (
        <div className="absolute left-0 z-40 mt-6 w-72 p-3 text-xs bg-white border border-neutral-200 rounded-xl shadow-lg top-0">
          <div className="mb-2 font-semibold text-neutral-700">Keterangan Status</div>
          <ul className="space-y-1.5 max-h-72 overflow-auto pr-1">
            {entries.map((entry) => (
              <li key={entry.value} className="leading-snug">
                <span className="font-semibold text-neutral-800">{entry.label}</span>
                <span className="text-neutral-500"> — {entry.description}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </span>
  )
}
